import { render, staticRenderFns } from "./SignCard.vue?vue&type=template&id=3bdc86a0&scoped=true"
import script from "./SignCard.vue?vue&type=script&lang=js"
export * from "./SignCard.vue?vue&type=script&lang=js"
import style0 from "./SignCard.vue?vue&type=style&index=0&id=3bdc86a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdc86a0",
  null
  
)

export default component.exports